import React from "react";
import "./MerchantHome.css";
import Sidebar from "./../controls/Sidebar.js";
import SelectableList from "../controls/SelectableList.js";
import Orders from "./Orders.js";
import Collection from "./Collection.js";
import { Route } from "react-router";
import Subheader from "material-ui/Subheader";
import { ListItem } from "material-ui/List";
import Divider from "material-ui/Divider";
import Request from "superagent";

const orders = [
  {
    id: "123",
    customerName: "Vivek Garg",
    customerAddress: "12 Nathan Pratt Drive, Unit 3",
    orderType: "Delivery",
    deliveryDate: "02/15/2017",
    amount: 25.26
  },
  {
    id: "234",
    customerName: "Pooja Garg",
    customerAddress: "12 Nathan Pratt Drive, Unit 3",
    orderType: "Pickup",
    deliveryDate: "02/15/2017",
    amount: 25.26
  }
];

const products = [
  {
    id: "123",
    name: "Product 1",
    quantity: 5,
    price: 1.99
  },
  {
    id: "234",
    name: "Product 2",
    quantity: 4,
    price: 2.49
  },
  {
    id: "345",
    name: "Product 1",
    quantity: 3,
    price: 3.99
  }
];

const apiHost = "http://localhost:8082";
const apiKey = "AIzaSyCNOzZ-dqhLR6GkKTJv0F8yo7eBJJuJQjo";
const pathCollectionFreshProduce = "/merchant/collections/fresh-produce";

export default class MerchantHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      products: [],
      intervalId: ""
    };
  }

  componentDidMount() {
    this.refreshProducts();
    var intervalId = setInterval(this.refreshProducts, 5000);
    this.setState({ intervalId: intervalId });
  }

  componentWillUnmount() {
    // use intervalId from the state to clear the interval
    clearInterval(this.state.intervalId);
  }

  apiEndpointURL(path) {
    return apiHost + path + "?key=" + apiKey;
  }

  refreshOrders = () => {
    this.setState({
      orders: orders
    });
  };

  completeOrder = orderID => {};

  showOrders = () => {
    this.context.router.push("/merchant/orders");
  };

  showInventory = () => {
    this.context.router.push(pathCollectionFreshProduce);
  };

  refreshProducts = () => {
    var url = this.apiEndpointURL(pathCollectionFreshProduce);
    var self = this;
    Request.get(url)
      .set("Authorization", "Bearer " + self.props.getToken())
      .end(function(err, res) {
        if (err || !res.ok) {
          console.log("Oh dang! error" + err);
        } else {
          self.setState({
            products: res.body
          });
        }
      });
  };

  updateInventory = products => {
    this.setState({
      products: []
    });
  };

  render() {
    return (
      <div className="merchant-home">
        <Sidebar
          open={this.props.sidebarOpen}
          toggleSidebar={this.props.toggleSidebar}
        >
          <SelectableList defaultValue={1}>
            <Subheader>Orders</Subheader>
            <ListItem
              value={1}
              primaryText="All Orders"
              onTouchTap={this.showOrders}
            />
            <ListItem
              value={2}
              primaryText="Upcoming Deliveries"
              onTouchTap={this.showOrders}
            />
            <ListItem
              value={3}
              primaryText="Upcoming Pickups"
              onTouchTap={this.showOrders}
            />
            <Divider />
            <Subheader>Inventory</Subheader>
            <ListItem
              value={4}
              primaryText="Fresh Produce Inventory"
              onTouchTap={this.showInventory}
            />
          </SelectableList>
        </Sidebar>
        <div className="merchant-content">
          <Route
            exact
            path="/merchant"
            render={() => <Orders orders={this.state.orders} />}
          />
          <Route
            exact
            path="/merchant/orders"
            render={() => <Orders orders={this.state.orders} />}
          />
          <Route
            exact
            path="/merchant/collections/:id"
            render={props => (
              <Collection
                products={this.state.products}
                updateInventory={this.updateInventory}
                {...props}
              />
            )}
          />
        </div>
      </div>
    );
  }
}

MerchantHome.propTypes = {
  getToken: React.PropTypes.func.isRequired
};

MerchantHome.contextTypes = {
  router: React.PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/merchant/MerchantHome.js